import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export * from './user';
export * from './cases';
export * from './copilot';
export * from './actions';

export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
